module.exports = __webpack_public_path__ + "img/imp_nemean.d6612895.png";